// extracted by mini-css-extract-plugin
module.exports = {"root":"_5f8701f","fallback":"_8003dfa","list":"_975294e","summary":"_bafeafe","result":"_76c237e","small":"_26d7e0a","payment":"_399ceee"};